import type { Bytes, StringGUID } from "@pdfking/tfunc"

import type { Allocated } from "./Allocated"
import type { PdfiumArguments, PdfiumReturns } from "./Bindings"
import type { PdfiumFunctions } from "./Bindings"
import type { Pointer } from "./Pointer"

export type PdfiumApi = {
  readonly id: StringGUID
  readonly call: <M extends PdfiumFunctions>(
    method: M,
    ...args: PdfiumArguments[M]
  ) => Promise<PdfiumReturns[M]>
  readonly safeCall: <M extends PdfiumFunctions>(
    method: M,
    ...args: PdfiumArguments[M]
  ) => Promise<PdfiumReturns[M]>
  readonly malloc: (size: Bytes) => Allocated
  readonly writeString: (str: string) => Allocated
  readonly writeBytes: (data: Uint8Array) => Allocated
  readonly writeTo: (ptr: Pointer, data: Uint8Array) => void
  readonly readBytes: (ptr: Pointer, size: Bytes) => Uint8Array
  readonly readFloats: (ptr: Pointer, count: number) => Float32Array
  readonly setInt32: (ptr: Pointer, value: number) => void
  readonly addCallback: (
    fn: (...args: number[]) => number,
    sig: string
  ) => Allocated
  readonly getMemorySize: () => Bytes
  readonly init: () => Promise<void>
  readonly dispose: () => Promise<void>
}

export type PdfiumApiFactory = (
  pdfiumPath?: string
) => Promise<() => Promise<PdfiumApi>>
